<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
        <loadingcomp v-bind:mesaj="''" v-model="loadingvmodel"></loadingcomp>

        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">{{
                $t("Definitions-v2")
              }}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-container fluid>
            <v-layout row="" wrap="">
              <router-link
                :to="{ name: 'coper-tanitimlar-parametre', params: { id: 0 } }"
              >
                <v-btn style="width: 200px" color="info" dark>
                  {{ $t("Region") }}
                  <v-icon right dark>travel_explore</v-icon>
                </v-btn>
              </router-link>

              <router-link
                :to="{ name: 'coper-tanitimlar-parametre', params: { id: 1 } }"
              >
                <v-btn style="width: 200px" color="info" dark>
                  {{ $t("Department") }}
                  <v-icon right dark>group_work</v-icon>
                </v-btn>
              </router-link>

              <router-link
                :to="{ name: 'coper-tanitimlar-parametre', params: { id: 2 } }"
              >
                <v-btn style="width: 200px" color="info" dark>
                  {{ $t("Management") }}
                  <v-icon right dark>supervised_user_circle</v-icon>
                </v-btn>
              </router-link>

              <router-link
                :to="{ name: 'coper-tanitimlar-parametre', params: { id: 3 } }"
              >
                <v-btn style="width: 200px" color="info" dark>
                  {{ $t("Department-v2") }}
                  <v-icon right dark>social_distance</v-icon>
                </v-btn>
              </router-link>

              <router-link
                :to="{ name: 'coper-tanitimlar-parametre', params: { id: 4 } }"
              >
                <v-btn style="width: 200px" color="info" dark>
                  {{ $t("Sub-Department") }}
                  <v-icon right dark>6_ft_apart</v-icon>
                </v-btn>
              </router-link>

              <router-link
                :to="{ name: 'coper-tanitimlar-parametre', params: { id: 5 } }"
              >
                <v-btn style="width: 200px" color="info" dark>
                  {{ $t("Visa-Price-Type") }}
                  <v-icon right dark>money</v-icon>
                </v-btn>
              </router-link>

              <router-link
                :to="{ name: 'coper-tanitimlar-parametre', params: { id: 6 } }"
              >
                <v-btn style="width: 200px" color="info" dark>
                  {{ $t("Agency-Department") }}
                  <v-icon right dark>water_damage</v-icon>
                </v-btn>
              </router-link>

              <router-link
                :to="{ name: 'coper-tanitimlar-parametre', params: { id: 7 } }"
              >
                <v-btn style="width: 200px" color="info" dark>
                  Sebep Kod
                  <v-icon right dark>contact_support</v-icon>
                </v-btn>
              </router-link>

              <router-link
                :to="{ name: 'coper-tanitimlar-parametre', params: { id: 8 } }"
              >
                <v-btn style="width: 200px" color="info" dark>
                  {{ $t("Hotel-Price-Code") }}
                  <v-icon right dark>money</v-icon>
                </v-btn>
              </router-link>

              <router-link :to="{ name: 'coper-parametreler' }">
                <v-btn style="width: 200px" color="info" dark>
                  {{ $t("Definitions") }}
                  <v-icon right dark>settings_suggest</v-icon>
                </v-btn>
              </router-link>

              <router-link :to="{ name: 'coper-tanitimlar-odatipleri' }">
                <v-btn style="width: 200px" color="info" dark>
                  {{ $t("Room-Types") }}
                  <v-icon right dark>meeting_room</v-icon>
                </v-btn>
              </router-link>
              <router-link
                :to="{ name: 'coper-tanitimlar-parametre', params: { id: 9 } }"
              >
                <v-btn style="width: 200px" color="info" dark>
                  {{ 'Paket Tur Kategoriler' }}
                  <v-icon right dark>money</v-icon>
                </v-btn>
              </router-link>
              <router-link
                :to="{ name: 'coper-tanitimlar-parametre', params: { id: 10 } }"
              >
                <v-btn style="width: 200px" color="info" dark>
                  {{ 'Paket Tur Ürün Grupları' }}
                  <v-icon right dark>money</v-icon>
                </v-btn>
              </router-link>
              <router-link
                :to="{ name: 'coper-tanitimlar-parametre', params: { id: 11 } }"
              >
                <v-btn style="width: 240px" color="info" dark>
                  {{ 'Paket Tur Ana Fiyat Grupları' }}
                  <v-icon right dark>money</v-icon>
                </v-btn>
              </router-link>
              <router-link
                :to="{ name: 'coper-tanitimlar-parametre', params: { id: 12 } }"
              >
                <v-btn style="width: 240px" color="info" dark>
                  {{ 'Paket Tur Alt Fiyat Grupları' }}
                  <v-icon right dark>money</v-icon>
                </v-btn>
              </router-link>
             <!--  <v-btn
                @click.native="TestClick()"
                style="width: 200px"
                color="info"
                dark
              > -->
              
              </v-btn>
            </v-layout>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import tool from "../tools";

export default {
  name: "coper-tanitimlar-parametrelist",
  data() {
    return {
      file: [],
      dosyayolu1: null,
      loadingvmodel: false,
      text1: null,
      snackbar: false,
      secilendosya: null,
      tooltip: false,
      el: null,
      valid: true,
      dialog: false,
      dosya1mesaj: null,
      yenikayit: false,

      dosyaokearsiv: false,
      dosyaokefatura: false,

      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          }
        });
    }
  },
  watch: {},
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
  methods: {
    addFiles() {
      this.$refs.file.click();
    },

    handleFileUpload2() {
      this.file = [];

      if (this.$refs.file.files != [] && this.$refs.file.files != null) {
        var uploadedFiles = this.$refs.file.files;

        var fp = document.getElementById("file");

        var lg = uploadedFiles.length; // get length
        if (lg > 0) {
          this.dosya1mesaj = lg + " " + this.$t("pcs-of-files-selected");
        } else {
          this.dosya1mesaj = this.$t("file-has-been-chosen");
        }
        document.getElementById("ulList").innerHTML = "";

        var items = uploadedFiles;
        var fragment = "";

        if (lg > 0) {
          for (var i = 0; i < lg; i++) {
            var fileName = items[i].name; // get file name
            var fileSize = items[i].size; // get file size
            var fileType = items[i].type; // get file type

            // append li to UL tag to display File info
            fragment += "<li>" + fileName + " (<b>" + fileSize + "</b> bytes)"; // + "- Type :" + fileType + "</li>";
          }
          document.getElementById("ulList").innerHTML = fragment;
          //contentWindow.document.body.innerHTML = response.body;
          // $("#ulList").append(fragment);
        }

        if (uploadedFiles.length > 0) {
          for (var i = 0; i < uploadedFiles.length; i++) {
            this.file.push(uploadedFiles[i]);
          }
        }
      }
    },

    TestClick() {
      this.Test(10);
      this.Test(10);
      this.Test(10);
      this.Test(10);

      this.Test(11);
      this.Test(11);
      this.Test(11);
      this.Test(11);

      this.Test(12);
      this.Test(12);
      this.Test(12);
      this.Test(12);

      this.Test(13);
      this.Test(13);
      this.Test(13);
      this.Test(13);

      this.Test(14);
      this.Test(14);
      this.Test(14);
      this.Test(14);
      

      this.Test(15);
      this.Test(15);
      this.Test(15);
      this.Test(15);
      

      this.Test(16);
      this.Test(16);
      this.Test(16);
      this.Test(16);
      

      this.Test(17);
      this.Test(17);
      this.Test(17);
      this.Test(17);
      

      this.Test(18);
      this.Test(18);
      this.Test(18);
      this.Test(18);
      

      this.Test(19);
      this.Test(19);
      this.Test(19);
      this.Test(19);
      
    },

    Test(val) {
      var params = {
        BiletNo: val,
      };

      tool.api_post(this, "Coper/TransactionTest", params).then(
        (response) => {
          if (response.body === true) {
          } else {
          }
        },
        (response) => {}
      );
    },
  },
};

function beforeMount() {}
</script>
